<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  width: 100%;
  height: 21vh;
  margin: 0 auto;
  color: #fff;
  text-align: center;

  // overflow: hidden;
  .bar3D {
    width: 100%;
    height: 120%;
    margin-top: -6vh;

    .main {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<template>
  <boxWrap :name="name" :min="min" :top="top">
    <div class="table">
      <div class="bar3D">
        <div class="main"></div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from "../common/boxWrap";
import echarts from "echarts";
var placeHolderStyle = {
  normal: {
    label: {
      show: false
    },
    labelLine: {
      show: false
    }
  }
};
export default {
  // props: ["salesData", "salesDataBar"],
  data() {
    return {
      name: "扫码量数据分析",
      dataY: [],
      min: "box-wrap2",
      top: "topname",
      dataX: [],
      tableData: [],
      chartData: []
    };
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener(
        "resize",
        function () {
          this.myChart.resize();
        }.bind(this)
      );
    },
    fontSize(res) {
      let docEl = document.documentElement
      let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (!clientWidth) {
        return;
      }
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    // getData() {
    //   this.myChart = echarts.init(document.querySelector(".bar3D .main"));
    //   this.myChart.clear();
    //   this.chart();
    // },
    chart() {
      this.data = [
        {
          value: 1207,
          name: "铁皮石斛"
        },
        {
          value: 7320,
          name: "安吉白茶"
        },
        {
          value: 1442,
          name: "马站四季柚"
        },
        {
          value: 386,
          name: "西湖龙井"
        },
        {
          value: 283,
          name: "西湖藕粉"
        }
      ];
      var obj = {
        铁皮石斛: 11.35,
        安吉白茶: 68.81,
        马站四季柚: 13.55,
        西湖龙井: 3.63,
        西湖藕粉: 2.66
      };
      this.myChart = echarts.init(document.querySelector(".bar3D .main"));
      var colors = [
        "#0036D4",
        "#3FECFF",
        "#4C63F2",
        "#FF610B",
        "#59D267",
        "#FDD100",
        "#00A1FD",
        "#FF7DA4"
      ];

      var op = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}:{d}%"
        },
        title: {
          text: "数据分析",
          x: "22%",
          y: "50%",
          textStyle: {
            fontSize: this.fontSize(0.16),
            fontWeight: "normal",
            color: ["#3FECFF"]
          }
        },
        legend: {
          orient: "vertical",
          right: this.fontSize(0.3),
          top: this.fontSize(0.55),
          data: ["铁皮石斛", "安吉白茶", "马站四季柚", "西湖龙井", "西湖藕粉"],
          formatter: function (name) {
            return "{title|" + name + "}:   {value|" + obj[name] + "%" + "}";
          },
          textStyle: {
            rich: {
              title: {
                fontSize: this.fontSize(0.16),
                lineHeight: this.fontSize(0.15),
                color: "rgb(0, 178, 246)"
              },
              value: {
                fontSize: this.fontSize(0.16),
                lineHeight: this.fontSize(0.15),
                color: "#fff"
              }
            }
          }
        },
        series: [
          {
            name: "扫码比重",
            tooltip: {
              show: false
            },
            type: "pie",
            center: ["30%", "55%"],
            selectedMode: "single",
            radius: [0, this.fontSize(0.4)],
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            color: colors,
            data: [
              {
                value: 335,
                name: "直达"
              }
            ]
          },
          {
            name: "扫码比重",
            type: "pie",
            center: ["30%", "55%"],
            radius: [this.fontSize(0.6), this.fontSize(0.8)],
            color: colors,
            labelLine: {
              normal: {
                show: false
              }
            },
            label: {
              show: false
            },
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            data: this.data
          }
        ]
      };
      this.myChart.setOption(op);
      this.init();

      // const that = this;
      // let index = 0;
      // clearInterval(this.timer);
      // this.timer = setInterval(() => {
      //   this.myChart.dispatchAction({
      //     type: "showTip",
      //     seriesIndex: 0,
      //     dataIndex: index
      //   });
      //   index++;
      //   // console.log(index)
      //   if (index >= 6) {
      //     index = 0;
      //   }
      // }, 3000);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    // this.tableData = this.salesData
    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
    // var myDate = new Date();
    // myDate.setDate(myDate.getDate() - 7);
    // var dateArray = []
    // var dateTemp;
    // var flag = 1;
    // for (var i = 0; i < time.length; i++) {
    //   let day = myDate.getDate() + i + 1;
    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
    //   this.dataY.push(this.salesDataBar[0][time[i]])
    //   this.dataX.push(dateTemp)
    // }

    // this.dataY = [80, 50, 60, 100, 150, 120]
    // this.dataX = ['1-18', '19-22', '23-35', '36-55', '56-75', '76-90']
    var self = this;
    self.chart();
    self.init();
    // this.timer = setInterval(() => {
    //   self.getData()
    // }, 3000);
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?000da889